import React from 'react';
import { FaUser, FaCalendarAlt, FaAward, FaCity, FaChalkboardTeacher } from 'react-icons/fa';


const TestResult = ({ name, fatherName, score, date, scholarship, classs, city, testName }) => {
    return (
        <div className="bg-gray-100 p-6 rounded-lg shadow-md">
            <div className=' flex flex-row flex-wrap justify-center gap-[max(15vw,1px)] align-middle'>
                <div>
                    <div className="flex items-center mb-4">
                        <FaUser className="mr-2 text-2xl text-gray-500" />
                        <div>
                            <p className="text-lg font-bold">{name}</p>
                            <p className="text-sm text-gray-500">Name</p>
                        </div>
                    </div>
                    <div className="flex items-center mb-4">
                        <FaUser className="mr-2 text-2xl text-gray-500" />
                        <div>
                            <p className="text-lg font-bold">{fatherName}</p>
                            <p className="text-sm text-gray-500">Father's Name</p>
                        </div>
                    </div>
                    <div className="flex items-center mb-4">
                        <FaChalkboardTeacher className="mr-2 text-2xl text-gray-500" />
                        <div>
                            <p className="text-lg">{classs}</p>
                            <p className="text-sm text-gray-500">Class</p>
                        </div>
                    </div>
                    <div className="flex items-center mb-4">
                        <FaChalkboardTeacher className="mr-2 text-2xl text-gray-500" />
                        <div>
                            <p className="text-lg">{city}</p>
                            <p className="text-sm text-gray-500">City</p>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="flex items-center mb-4">
                        <FaAward className="mr-2 text-2xl text-gray-500" />
                        <div>
                            <p className="text-3xl font-bold">{score}</p>
                            <p className="text-sm text-gray-500">Score</p>
                        </div>
                    </div>
                    <div className="flex items-center mb-4">
                        <FaCalendarAlt className="mr-2 text-2xl text-gray-500" />
                        <div>
                            <p className="text-lg">{date}</p>
                            <p className="text-sm text-gray-500">Date</p>
                        </div>
                    </div>
                    <div className="flex items-center">
                        <FaAward className="mr-2 text-2xl text-gray-500" />
                        <div>
                            <p className="text-lg">{scholarship}</p>
                            <p className="text-sm text-gray-500">Scholarship</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="text-sm text-gray-500">Test Name : <span className='font-extrabold text-black'>{testName}</span></div>
        </div>
    );
};

export default TestResult;
